import _ from 'lodash';

export default {
	add(state, items, type, key) {
		state.isSuccess = false;

		const string = type === 'goods' ? '제품' : '상품';

		if (items.length === 0) {
			alert(`선택한 ${string}이 없습니다.`);
			return;
		}

		const current = [
			..._.sortBy(_.cloneDeep(state.selected), ['priority']),
		];
		const prevLength = current.length;

		_.each(items, item => {
			item.checked = false;
			item.title = '';

			if (type === 'goods') {
				item.badge = null;
			} else {
				item.description = '';
			}

			current.push(item);
		});

		const uniqList = _.uniqBy(current, key);

		_.each(uniqList, (item, index) => {
			item.priority = index;
		});

		if (uniqList.length > 10) {
			alert(`${string}은 최대 10개까지만 추가할 수 있습니다.`);
		} else {
			state.selected = uniqList;
			alert(
				`${state.selected.length - prevLength}개의 ${string}이 추가되었습니다.\n동일한 항목은 한번만 추가됩니다.`
			);
			state.isSuccess = true;
		}
	},
	move(state, section, target, direction) {
		let targetIndex = [];
		let lastIndex = state.selected.length - 1;
		let topIndex = 0;

		_.each(target, code => {
			if (section === 'products') {
				targetIndex.push(
					_.findIndex(state.selected, { productCode: code })
				);
			} else if (section === 'goods') {
				targetIndex.push(
					_.findIndex(state.selected, { idProduct: code })
				);
			}
		});

		if (direction === 'up') {
			targetIndex = _.sortBy(targetIndex);
		} else {
			targetIndex = _.sortBy(targetIndex).reverse();
		}

		_.each(targetIndex, index => {
			if (direction === 'up') {
				if (index !== topIndex) {
					[
						state.selected[index].priority,
						state.selected[index - 1].priority,
					] = [
						state.selected[index - 1].priority,
						state.selected[index].priority,
					];
				}

				topIndex++;
			} else {
				if (index !== lastIndex) {
					[
						state.selected[index].priority,
						state.selected[index + 1].priority,
					] = [
						state.selected[index + 1].priority,
						state.selected[index].priority,
					];
				}

				lastIndex--;
			}

			state.selected = _.orderBy(state.selected, ['priority', 'desc']);
		});
	},

	end(state, section, target, direction) {
		const ends = [];

		_.each(target, code => {
			let index;

			if (section === 'products') {
				index = _.findIndex(state.selected, { productCode: code });
			} else if (section === 'goods') {
				index = _.findIndex(state.selected, { idProduct: code });
			}

			ends.push(state.selected[index]);
			state.selected.splice(index, 1);
		});

		if (direction === 'top') {
			state.selected = [...ends, ...state.selected];
		} else {
			state.selected = [...state.selected, ...ends];
		}

		_.each(state.selected, (item, index) => {
			item.priority = index;
		});
	},
};
